import axios from 'axios';
import moment from 'moment';
import i18n from './../i18n';
import persistentData from '@/plugins/persistentData';
//import { useRouter } from 'vue-router';
//import { useStore } from 'vuex';

//const route = useRoute();
//const router = useRouter();
//const store = useStore();

const instance = axios.create({
  timeout: 300000,
});

function getHeaders(isAnon = false) {
  let params = {
    LANG: i18n.global.locale.value.toUpperCase(),
    'Content-Type': 'application/json',
    CLIENT_DATETIME: moment().format('DD/MM/YYYY HH:mm'),
  };
  if (!isAnon && persistentData.get('token', false)) {
    params.Authorization = `Bearer ${persistentData.get('token', false)}`;
  }
  return params;
}

const interceptor = {
  getParameterByName(name, url = window.location.href) {
    // eslint-disable-next-line no-useless-escape
    const cleanName = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + cleanName + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  checkVersion:(resolve, res,url)  => {
    if (!url.includes(process.env.VUE_APP_API_LMS_URL) && !url.includes(process.env.VUE_APP_API_LMS_ADMIN_URL)) {
      resolve(res);
    }
    else {
      // Check version
      const responseVersion = res.headers['x-app-v'];
      const localVersion = localStorage.getItem('x-app-v');

      if (responseVersion) {
        if (localVersion && responseVersion !== localVersion) {
          localStorage.setItem('x-app-v', responseVersion);
          setTimeout(() => {
            location.reload(true);
          });
        } else if (!localVersion) {
          localStorage.setItem('x-app-v', responseVersion);
        }
      }

      resolve(res);
    }
  },
  anonymous: {
    get: (url) => {
      return new Promise((resolve, reject) => {
        instance
          .get(url, { headers: getHeaders(true) })
          .then((res) => {
            interceptor.checkVersion(resolve, res, url);
          })
          .catch((error) => {
            reject('Error in anonymous Get: ' + error.message);
          });
      });
    },
    getBackend: (url) => {
      return instance.get(url, { withCredentials: true });
    },
    post: (url, params) => {
      return instance.post(url, params, { headers: getHeaders(true) });
    },
  },
  authenticate: {
    refreshToken: () => {
      return new Promise((resolve, reject) => {
        instance
          .post(
            `${process.env.VUE_APP_API_SECURITY_URL}/Security/refreshToken`,
            { value: persistentData.get('token', false) }
          )
          .then((res) => {
            const expired = moment().add(13, 'm').format();
            persistentData.set('tokenExpired', expired, false);
            resolve(res);
          })
          .catch((err) => {
            persistentData.remove('token');
            persistentData.remove('tokenExpiration');
            //let store = useStore();
            window.MainApp.$store.commit(
              'redirectAfterLogin',
              window.MainApp.$route.path
            );
            
            const storedUser = JSON.parse(persistentData.get('user'));
            if(storedUser != null && storedUser != undefined && storedUser.role.toLowerCase() == 'learninguser'){
              window.location.href = process.env.VUE_APP_LMS_SSO_FROM_URL;
            }
            else{
              window.MainApp.$router.push('/login');
            }
            //router.push('/login')
            reject(err);
          });
      });
    },
    validateToken: () => {
      const self = interceptor.authenticate;
      return new Promise((resolve) => {
        const expired = moment(persistentData.get('tokenExpired', false));
        if (expired.diff(moment().utc(), 'm') < 1) {
          self.refreshToken().then(() => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    get: (url) => {
      const self = interceptor.authenticate;
      return new Promise((resolve, reject) => {
        self.validateToken().then(() => {
          instance
            .get(url, { headers: getHeaders() })
            .then((res) => {


              interceptor.checkVersion(resolve, res, url);

              
            })
            .catch((err) => {
              console.log(err);
              if (
                err.response.status === 401 &&
                err.response.data !== 'USER_ROLE_NOT_ALLOWED'
              ) {
                // Refresk Token
                self.refreshToken().then((res_token) => {
                  persistentData.set('token', res_token.data.token, false);
                  instance
                    .get(url, { headers: getHeaders() })
                    .then((res) => resolve(res))
                    .catch((err) => {
                      reject(err);
                    });
                });
              }
              reject(err);
            });
        });
      });
    },
    getFile: (url, fileName, type = 'application/vnd.ms-excel') => {
      const self = interceptor.authenticate;
      return new Promise((resolve, reject) => {
        self.validateToken().then(() => {
          instance
            .get(url, { headers: getHeaders(), responseType: 'blob' })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type,
                })
              );
              const link = document.createElement('a');
              link.href = url;
              // replace "." from file name to "-"
              const sanitizedFileName = fileName.replace(/\./g, '-');
              link.setAttribute('download', sanitizedFileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
              resolve();
            })
            .catch((err) => {
              if (err.response.status === 401) {
                // Refresk Token
                self.refreshToken().then((res_token) => {
                  persistentData.set('token', res_token.data.token, false);
                  instance
                    .get(url, { headers: getHeaders(), responseType: 'blob' })
                    .then((res) => {
                      const url = URL.createObjectURL(
                        new Blob([res.data], {
                          type,
                        })
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      // replace "." from file name to "-"
                      const sanitizedFileName = fileName.replace(/\./g, '-');
                      link.setAttribute('download', sanitizedFileName);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      resolve();
                    })
                    .catch((err) => {
                      reject(err);
                    });
                });
              }
              reject(err);
            });
        });
      });
    },
    post: (url, params) => {
      const self = interceptor.authenticate;
      return new Promise((resolve, reject) => {
        self.validateToken().then(() => {
          instance
            .post(url, params, { headers: getHeaders() })
            .then((res) => resolve(res))
            .catch((err) => {
              console.log(err);
              if (err.response.status === 401) {
                // Refresk Token
                self.refreshToken().then((res_token) => {
                  persistentData.set('token', res_token.data.token, false);
                  instance
                    .post(url, params, { headers: getHeaders() })
                    .then((res) => resolve(res))
                    .catch((err) => {
                      reject(err);
                    });
                });
              }
              reject(err);
            });
        });
      });
    },
    delete: (url, params) => {
      const self = interceptor.authenticate;
      return new Promise((resolve, reject) => {
        self.validateToken().then(() => {
          instance
            .delete(url, { headers: getHeaders(), data:params })
            .then((res) => resolve(res))
            .catch((err) => {
              console.log(err);
              if (err.response.status === 401) {
                // Refresk Token
                self.refreshToken().then((res_token) => {
                  persistentData.set('token', res_token.data.token, false);
                  instance
                    .delete(url, { headers: getHeaders(), data:params })
                    .then((res) => resolve(res))
                    .catch((err) => {
                      reject(err);
                    });
                });
              }
              reject(err);
            });
        });
      });
    },
    put: (url, params) => {
      const self = interceptor.authenticate;
      return new Promise((resolve, reject) => {
        self.validateToken().then(() => {
          instance
            .put(url, params, { headers: getHeaders() })
            .then((res) => resolve(res))
            .catch((err) => {
              console.log(err);
              if (err.response.status === 401) {
                // Refresk Token
                self.refreshToken().then((res_token) => {
                  persistentData.set('token', res_token.data.token, false);
                  instance
                    .put(url, params, { headers: getHeaders() })
                    .then((res) => resolve(res))
                    .catch((err) => {
                      reject(err);
                    });
                });
              }
              reject(err);
            });
        });
      });
    },
    patch: (url, params) => {
      const self = interceptor.authenticate;
      return new Promise((resolve, reject) => {
        self.validateToken().then(() => {
          instance
            .patch(url, params, { headers: getHeaders() })
            .then((res) => resolve(res))
            .catch((err) => {
              console.log(err);
              if (err.response.status === 401) {
                // Refresk Token
                self.refreshToken().then((res_token) => {
                  persistentData.set('token', res_token.data.token, false);
                  instance
                    .put(url, params, { headers: getHeaders() })
                    .then((res) => resolve(res))
                    .catch((err) => {
                      reject(err);
                    });
                });
              }
              reject(err);
            });
        });
      });
    },
  },
};

export default interceptor;
